/**
 * Represente la position d'un noeud.
 */
export class NodePosition {
    /**
     * Construction.
     * @param x : Position horizontale du noeud.
     * @param y : Position verticale du noeud.
     */
    public constructor(
        public x: number,
        public y: number
    ) {}
}
